/** Fox ESS module sizes shown on the example plan and the customer plan. */
export const PRIMARY_BATTERY_KWH = [0, 5.76, 11.52, 17.28] as const;
export const EXTRA_BATTERY_KWH = [23.04, 28.8, 34.56, 40.32] as const;
export const EXAMPLE_BATTERY_KWH = [...PRIMARY_BATTERY_KWH, ...EXTRA_BATTERY_KWH];
export const AI_PICK_BATTERY_KWH = 11.52;

const MATCH_TOLERANCE = 0.06;

export function batteryLabel(kwh: number): string {
  return kwh <= 0 ? "No battery" : `${kwh} kWh`;
}

function takeMatching(choices: number[], targets: readonly number[]): { matched: number[]; rest: number[] } {
  const rest = [...choices];
  const matched: number[] = [];
  for (const target of targets) {
    const index = rest.findIndex((value) => Math.abs(value - target) < MATCH_TOLERANCE);
    if (index < 0) continue;
    matched.push(rest[index]);
    rest.splice(index, 1);
  }
  return { matched, rest };
}

/** Group catalog sizes into the primary row and the "Need more storage?" row. */
export function splitBatteryChoices(choices: number[]): { primary: number[]; extra: number[] } {
  const primaryPass = takeMatching(choices, PRIMARY_BATTERY_KWH);
  const extraPass = takeMatching(primaryPass.rest, EXTRA_BATTERY_KWH);
  const primary = [...primaryPass.matched];
  const extra = [...extraPass.matched];
  for (const value of extraPass.rest) {
    if (value <= 17.28) primary.push(value);
    else extra.push(value);
  }
  primary.sort((a, b) => a - b);
  extra.sort((a, b) => a - b);
  return { primary, extra };
}
